import { render, staticRenderFns } from "./DialogTemplateEmailDelete.vue?vue&type=template&id=68110798&"
import script from "./DialogTemplateEmailDelete.vue?vue&type=script&lang=js&"
export * from "./DialogTemplateEmailDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports